import React from 'react';
import CloseIcon from 'views/components/icons/Close';
import cn from 'classnames';
import ToggleButton from 'views/components/ToggleButton';
import Select from 'react-select';
import InfoIcon from 'views/components/icons/Info';
import { capacityOnRamps } from './selectOptions';
import { getTheme } from 'utils/SelectTheme';
import DropdownStyles from '../DropdownStyles';

const Capacity = ({ capacityConfiguration, setCapacityConfiguration, capOnRamp, setCapOnRamp }) => {
  const updateConfiguration = (newValue) => {
    setCapacityConfiguration({ ...capacityConfiguration, ...newValue });
  };

  const defaultConfiguration = {
    datacenters: false,
    cabe: null,
    kva: null,
    cooling: false,
    metro: 'total',
    cabinet: 'average',
  };

  // const cabeOptions = [
  //   { label: 'Total', value: 'total' },
  //   { label: 'Available', value: 'available' },
  // ];
  // const metroOptions = [
  //   { label: 'Total', value: 'total' },
  //   { label: 'Available', value: 'available' },
  // ];
  // const cabinetOptions = [
  //   { label: 'Available Average', value: 'average' },
  //   { label: 'Available Maximum', value: 'maximum' },
  // ];
  const asDefault = JSON.stringify(defaultConfiguration) === JSON.stringify(capacityConfiguration);
  return (
    <div className={cn('capacity-view')} data-testid={'capacity-menu'}>
      <ul>
        <li>
          <span className="subsection-title">Show for:</span>
          <div className="select-wrapper">
            <Select
              classNamePrefix="select"
              value={capacityOnRamps.find((i) => i.value === capOnRamp)}
              onChange={(e) => setCapOnRamp(e.value)}
              options={capacityOnRamps}
              isSearchable={false}
              theme={getTheme}
              menuPlacement={'auto'}
              menuPosition={'fixed'}
              styles={DropdownStyles}
            />
          </div>
        </li>
      </ul>
      <div className={'separator-line'} />
      <ul className={cn('actions-list', { disabled: asDefault })}>
        <li onClick={() => setCapacityConfiguration(defaultConfiguration)}>
          <p>Clear Selection</p>
          <CloseIcon width={10} height={10} color="#000000" />
        </li>
      </ul>
      <div className={'separator-line'} />
      <div className="section-title">
        <span>SPACE</span>
      </div>
      <ul>
        <li onClick={() => updateConfiguration({ datacenters: !capacityConfiguration.datacenters })}>
          <span>Number of Data Centers</span>
          <ToggleButton
            small
            checked={capacityConfiguration.datacenters}
            onToggled={() => updateConfiguration({ datacenters: !capacityConfiguration.datacenters })}
          />
        </li>
      </ul>
      <ul>
        <li onClick={() => updateConfiguration({ cabe: capacityConfiguration.cabe === null ? 'available' : null })}>
          <span>
            Available CabE per Metro
            <div className="tooltip">
              <InfoIcon width={18} height={18} color="#707073" />
              <span className="tooltiptext top-tooltip">Secure Cabinet Express</span>
            </div>
          </span>
          <ToggleButton
            small
            checked={capacityConfiguration.cabe !== null}
            onToggled={() => updateConfiguration({ cabe: capacityConfiguration.cabe === null ? 'available' : null })}
          />
        </li>
        {/* <div className={cn('dropdown-section', { visible: capacityConfiguration.cabe !== null })}>
            <li>
              <div className="select-wrapper">
                <Select
                  classNamePrefix="select"
                  value={cabeOptions.find((i) => i.value === capacityConfiguration.cabe)}
                  onChange={(e) => setCapacityConfiguration({ ...capacityConfiguration, cabe: e.value })}
                  options={cabeOptions}
                  isSearchable={false}
                  theme={getTheme}
                  menuPlacement={'auto'}
                  menuPosition={'fixed'}
                  styles={DropdownStyles}
                  autosize={true}
                />
              </div>
            </li>
          </div> */}
      </ul>
      {/* <div className={'separator-line'} /> */}
      {/* <span className="section-title">POWER</span>
        <ul>
          <li>
            <span>kVA</span>
            <ToggleButton
              small
              checked={capacityConfiguration.kva !== null}
              onToggled={() => updateConfiguration({ kva: capacityConfiguration.kva === null ? 'metro' : null })}
            />
          </li>
          <div className={cn('dropdown-section', { visible: capacityConfiguration.kva !== null })}>
            <li>
              <label>
                <input
                  type="radio"
                  value={'metro'}
                  checked={'metro' === capacityConfiguration.kva}
                  onChange={(e) => setCapacityConfiguration({ ...capacityConfiguration, kva: e.target.value })}
                />
                Per Metro
              </label>
              <label>
                <input
                  type="radio"
                  value="cabinet"
                  checked={'cabinet' === capacityConfiguration.kva}
                  onChange={(e) => setCapacityConfiguration({ ...capacityConfiguration, kva: e.target.value })}
                />
                Per Cabinet
              </label>
            </li>
            <li>
              <div className="select-wrapper">
                {capacityConfiguration.kva === 'metro' ? (
                  <Select
                    classNamePrefix="select"
                    value={metroOptions.find((i) => i.value === capacityConfiguration.metro)}
                    onChange={(e) => setCapacityConfiguration({ ...capacityConfiguration, metro: e.value })}
                    options={metroOptions}
                    isSearchable={false}
                    theme={getTheme}
                    menuPlacement={'auto'}
                    menuPosition={'fixed'}
                    styles={DropdownStyles}
                    autosize={true}
                  />
                ) : (
                  <Select
                    classNamePrefix="select"
                    value={cabinetOptions.find((i) => i.value === capacityConfiguration.cabinet)}
                    onChange={(e) => setCapacityConfiguration({ ...capacityConfiguration, cabinet: e.value })}
                    options={cabinetOptions}
                    isSearchable={false}
                    theme={getTheme}
                    menuPlacement={'auto'}
                    menuPosition={'fixed'}
                    styles={DropdownStyles}
                    autosize={true}
                  />
                )}
              </div>
            </li>
          </div>
        </ul> */}
      <div className={'separator-line'} />
      <div className="section-title">
        <span>COOLING</span>
        {/* TODO: refactor tooltip, create component and replace existing tooltips */}
        <div className="tooltip">
          <InfoIcon width={18} height={18} color="#707073" />
          <span className="tooltiptext">Augmented Air Cooling or Liquid Cooling available</span>
        </div>
      </div>
      <ul>
        <li onClick={() => updateConfiguration({ cooling: !capacityConfiguration.cooling })}>
          <span>High-Density Cooling</span>
          <ToggleButton small checked={capacityConfiguration.cooling} onToggled={() => updateConfiguration({ cooling: !capacityConfiguration.cooling })} />
        </li>
      </ul>
    </div>
  );
};

export default Capacity;
